import React from 'react';
// Make sure to have MouseFollower.jsx in the same directory or update the path
import MouseFollower from './Mousefollower';

const AboutSection = () => {
  const metrics = [
    { value: '500+', label: 'Active Retail Partners' },
    { value: '$50M+', label: 'Wholesale Value Shipped' },
    { value: '10k+', label: 'Products in Catalog' },
    { value: '98%', label: 'Fulfillment Rate' },
  ];

  return (
    <section className="relative min-h-[600px] bg-gray-200 py-24 px-6 md:px-12 lg:px-24 flex items-center overflow-hidden cursor-none md:cursor-default font-sans">
      {/* Import the mouse follower component for animation */}
      <MouseFollower />

      <div className="max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-8 items-start ml-10">
        
        {/* --- LEFT COLUMN: Text Content --- */}
        <div className="flex flex-col space-y-12">
          {/* Headline */}
          <h2 className="text-5xl md:text-6xl leading-tight font-bold text-slate-900">
            Powering your <br />
            wholesale business <br />
            <span className="text-slate-400">with Daily Go</span>
          </h2>

          {/* Body Text */}
          <p className="text-slate-600 text-lg md:text-xl leading-relaxed max-w-xl">
            Streamline your supply chain and scale faster. Daily Go simplifies B2B sourcing, offering a vast catalog and reliable bulk fulfillment. 
            Our platform is designed to help retailers and businesses achieve more with less effort. 
            <span className="text-slate-400"> Join hundreds of partners who have transformed their procurement process.</span>
          </p>
        </div>

        {/* --- RIGHT COLUMN: Metrics Grid --- */}
        <div className="grid grid-cols-2 gap-x-8 gap-y-16 lg:pl-12 pt-4">
          {metrics.map((metric, index) => (
            <div key={index} className="flex flex-col items-start">
              <span className="text-5xl md:text-6xl font-bold text-slate-900 block mb-2">
                {metric.value}
              </span>
              <span className="text-sm md:text-base font-medium text-slate-500 uppercase tracking-wider">
                {metric.label}
              </span>
            </div>
          ))}
        </div>
        
      </div>
    </section>
  );
};

export default AboutSection;